import { Asset } from 'contentful'
import { HTMLAttributes } from 'react'

type ContentfulImageProps = {
  asset: Asset
  width?: number
  height?: number
  format?: 'webp' | 'png' | 'jpg'
} & HTMLAttributes<HTMLImageElement>

const sizeParam = ({
  axis: direction,
  base,
  multiplier,
}: {
  axis: 'w' | 'h'
  base?: number
  multiplier: number
}) => {
  if (base) {
    return `${direction}=${base * multiplier}`
  }
}

export const ContentfulImage = ({
  asset,
  style,
  width,
  height,
  format = 'jpg',
  ...imageProps
}: ContentfulImageProps) => {
  const path = asset.fields.file?.url
  if (!path || path.includes('downloads')) {
    return null
  }
  const resolvedWidth = width ?? 0
  const resolvedHeight = height ?? 0
  const searchParams = [
    `fm=${format}`,
    sizeParam({ axis: 'w', base: resolvedWidth, multiplier: 1 }),
    sizeParam({ axis: 'h', base: resolvedHeight, multiplier: 1 }),
  ]
    .filter(Boolean)
    .join('&')

  const srcSetParams = [1, 2, 3].map(multiplier =>
    [
      `fm=${format}`,
      sizeParam({
        axis: 'w',
        base: resolvedWidth,
        multiplier,
      }),
      sizeParam({
        axis: 'h',
        base: resolvedHeight,
        multiplier,
      }),
    ]
      .filter(Boolean)
      .join('&')
  )

  return (
    <img
      {...imageProps}
      style={style}
      src={`${path}?${searchParams}`}
      srcSet={`${path}?${srcSetParams[0]}, ${path}?${srcSetParams[1]} 2x, ${path}?${srcSetParams[1]} 3x`}
      alt={asset.fields.title}
      loading="lazy"
    />
  )
}
